// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"TextInput_tooltip__BOU3Y"};